import { ChartData, ChartOptions } from 'chart.js'
import { enhancementTypes } from '../../../../utils/constants'
import { getBaseChartOptions } from '../common'
import { PeriodType } from '../../PeriodTypeSelector'

export const ENHANCEMENT_TYPE_COLOR_MAP = {
  [enhancementTypes.onCall]: {
    backgroundColor: 'rgb(64, 27, 186)'
  },
  [enhancementTypes.callOut]: {
    backgroundColor: 'rgb(188, 24, 175)'
  },
  [enhancementTypes.overtime]: {
    backgroundColor: 'rgb(240, 135, 12)'
  },
  [enhancementTypes.night]: {
    backgroundColor: 'rgb(49, 48, 87)',
  },
  [enhancementTypes.weekend]: {
    backgroundColor: 'rgb(111, 109, 234)'
  }
} as const

export const getChartOptions = (labels: string[] = [], periodType: PeriodType = PeriodType.MONTH): ChartOptions<'line'> => ({
  ...getBaseChartOptions(),
  layout: {
    padding: {
      left: 10,
      right: 20,
      top: 30,
      bottom: 10
    }
  },
  scales: {
    y: {
      grace: '10%',
      beginAtZero: true,
      title: {
        display: true,
        text: 'Paid Hours',
        font: {
          weight: 'bold' as const
        }
      }
    },
    x: {
      offset: true,
      title: {
        display: true,
        text: periodType,
        font: {
          weight: 'bold' as const
        }
      },
      ticks: {
        autoSkip: false,
        padding: 10
      }
    }
  },
  plugins: {
    ...getBaseChartOptions().plugins,
    tooltip: {
      intersect: false,
      enabled: true
    }
  }
})

export const getChartDataConfig = (
  labels: string[],
  paidHoursByRequestTypeByMonth: Record<string, Record<string, number>>
): ChartData<'line'> => ({
  labels,
  datasets: Object.keys(paidHoursByRequestTypeByMonth)
    .filter(requestType => ENHANCEMENT_TYPE_COLOR_MAP[requestType as keyof typeof ENHANCEMENT_TYPE_COLOR_MAP])
    .map((requestType) => ({
      label: requestType,
      data: labels.map((month) => paidHoursByRequestTypeByMonth[requestType]?.[month] || 0),
      backgroundColor: ENHANCEMENT_TYPE_COLOR_MAP[requestType as keyof typeof ENHANCEMENT_TYPE_COLOR_MAP].backgroundColor,
      borderColor: ENHANCEMENT_TYPE_COLOR_MAP[requestType as keyof typeof ENHANCEMENT_TYPE_COLOR_MAP].backgroundColor,
      tension: 0,
      pointRadius: 4,
      pointHoverRadius: 6
    }))
})